import { render, staticRenderFns } from "./JSelectMultiple.vue?vue&type=template&id=6b36d040"
import script from "./JSelectMultiple.vue?vue&type=script&lang=js"
export * from "./JSelectMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports